import { without } from 'lodash';
import {
  custom,
  labeled,
  enumRequired,
  emailOptional,
  guidRequired,
  phoneCodeOptional,
  phoneNumberOptional,
  stringRequired
} from '../../util/joi';
import { PersonalTitle, personalTitles } from '../global/PersonalTitle.enum';

export const schema = (Joi: any, label: string) => {
  const availablePersonalTitles = without(personalTitles, PersonalTitle.none.name);
  return custom(Joi)
    .object()
    .keys({
      id: guidRequired(Joi).label(labeled(label, 'ID')),
      title: enumRequired(Joi, availablePersonalTitles, labeled(label, 'Title')),
      firstName: stringRequired(Joi, 1, 64).label(labeled(label, 'First name')),
      familyName: stringRequired(Joi, 1, 64).label(labeled(label, 'Family name')),
      phoneCode: phoneCodeOptional(Joi).label(labeled(label, 'Phone code')),
      phone: phoneNumberOptional(Joi).label(labeled(label, 'Phone number')),
      email: emailOptional(Joi).label(labeled(label, 'E-Mail address'))
    })
    .label(labeled(label, 'Type -'));
};

export default {
  schema
};
